import { Entity, EntityMap, RejectedError } from './types';

import { objectWithoutKeys } from '.';

/**
 * Removes by IDs the entities from pending, fulfilled and rejected entity maps.
 */
type Remove = <T extends Entity>(state: EntityMap<T>, ids: T['id'][]) => EntityMap<T>;
export const remove: Remove = (state, ids) => {
  const newPending = objectWithoutKeys<boolean>(state.pending.byId, ids);
  const newFulfilled = objectWithoutKeys(state.fulfilled.byId, ids);
  const newRejected = objectWithoutKeys<RejectedError>(state.rejected.byId, ids);

  return {
    ...state,
    pending: {
      ...state.pending,
      byId: newPending,
    },
    fulfilled: {
      ...state.fulfilled,
      byId: newFulfilled,
    },
    rejected: {
      ...state.rejected,
      byId: newRejected,
    },
  };
};
